import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '沖縄での起業に特化したホームページ制作の特徴は何ですか？',
      answer: '琉球人による現地視点でのデザインとコンテンツ制作、沖縄の市場ニーズに合わせたSEO対策、地域密着型のキーワード戦略を重視しています。「沖縄 カフェ 新規オープン」「沖縄 ネイルサロン LP」などの地域特化キーワードで上位表示を目指します。'
    },
    {
      question: 'どのような業種に対応していますか？',
      answer: '美容・ヘアサロン、ネイルサロン、エステサロン、マッサージ・整体、カフェ・飲食店、コンサルティング業など、沖縄で起業される様々な業種に対応しています。それぞれの業界特性を理解した専門的なサイト制作を行います。'
    },
    {
      question: '制作期間はどのくらいかかりますか？',
      answer: 'プランによって異なりますが、LP制作は1週間以内、ホームページ制作は約1ヶ月、セットプランで約1.5ヶ月が目安となります。お急ぎの場合はご相談ください。'
    },
    {
      question: 'SEO対策はどのような内容ですか？',
      answer: '沖縄地域に特化したキーワード戦略、Googleマイビジネス最適化、地域密着型コンテンツ制作、モバイル最適化、ページ速度改善など、地域SEOを重視した包括的な対策を行います。'
    },
    {
      question: 'アフターサポートはありますか？',
      answer: 'はい、全プランにアフターサポートが含まれています。技術的なサポート、コンテンツ更新のアドバイス、SEO効果の分析レポートなど、継続的にサポートいたします。沖縄県内での対面サポートも可能です。'
    },
    {
      question: '料金の支払い方法を教えてください',
      answer: '銀行振込、クレジットカード決済に対応しています。分割払いも可能ですので、起業資金に配慮した柔軟な支払いプランをご相談ください。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            よくある<strong>ご質問</strong>
          </h3>
          <p className="text-xl text-gray-600">
            沖縄での起業・ホームページ制作に関するよくあるご質問にお答えします
          </p>
        </div>

        <div className="space-y-4" itemScope itemType="https://schema.org/FAQPage">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="border border-gray-200 rounded-lg overflow-hidden"
              itemScope 
              itemProp="mainEntity" 
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer flex justify-between items-center"
              >
                <h4 className="font-semibold text-gray-900 pr-4" itemProp="name">
                  {faq.question}
                </h4>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-gray-500 flex-shrink-0`}></i>
              </button>
              
              {openIndex === index && (
                <div 
                  className="px-6 py-4 bg-white border-t border-gray-200"
                  itemScope 
                  itemProp="acceptedAnswer" 
                  itemType="https://schema.org/Answer"
                >
                  <p className="text-gray-700 leading-relaxed" itemProp="text">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            その他のご質問がございましたら、お気軽にお問い合わせください
          </p>
          <a 
            href="#contact" 
            className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium cursor-pointer"
          >
            お問い合わせはこちら <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
